<template>
  <div class="mainList">
    <el-table :data="tabData" style="width: 100%" class="myTable" min-height="500">
      <el-table-column prop="date" label="日期" width="150"> </el-table-column>
      <el-table-column prop="registerCount" label="注册人数" />
      <el-table-column prop="firstDepositNum" label="首冲人数" />
      <el-table-column prop="tradeUserCount" label="开仓人数" />
      <el-table-column prop="positionUidCount" label="平仓人数" />
      <el-table-column prop="positionCount" label="平仓数量" />
      <!-- <el-table-column prop="depositAmount" label="充值" width="160" /> -->

      <el-table-column prop="depositAmount" label="充值" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openRecords(scope.row, 1, '充值记录')">{{ scope.row.depositAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="withdrawAmount" label="提现" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openRecords(scope.row, -1, '提现记录')">{{ scope.row.withdrawAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="internalTransferInAmount" label="内部转入" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openRecords(scope.row, -2, '内部转入记录', 'internal')">{{
            scope.row.internalTransferInAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="internalTransferOutAmount" label="内部转出" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openRecords(scope.row, -2, '内部转出记录')">{{ scope.row.internalTransferOutAmount
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="withdrawAmount" label="提现" width="160" /> -->
      <el-table-column prop="cast" label="资金费用" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openFundDialog(scope.row)">{{
            scope.row.cast
            }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="withdrawFee" label="提现手续费" width="160" />
      <!-- <el-table-column prop="highCountFee" label="高频手续费" width="160" />
      <el-table-column prop="shortLineFee" label="超短线手续费" width="160" /> -->
      <el-table-column prop="netWorthDeposit" label="净充值" width="120" />
      <!-- <el-table-column prop="totalDeposit" label="净入金" width="160" /> -->
      <el-table-column prop="userBalance" label="用户余额" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openDialog(scope.row)">{{
            scope.row.userBalance
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="walletBalance" label="钱包余额" width="160" />

      <el-table-column prop="totalFee" label="总手续费" width="160" />
      <el-table-column prop="experienceDeductFee" label="体验金抵扣手续费(USDT)" width="180" />
      <el-table-column prop="positionProfit" label="平仓盈亏" width="160" />
      <el-table-column prop="experiencePnlDeduct" label="体验金抵扣盈亏(USDT)" width="180" />
      <el-table-column prop="experienceFundingFeeDeduct" label="体验金抵扣资金费(USDT)" width="190" />
      <el-table-column prop="feeCouponDeduct" label="手续费抵扣券抵扣金额(USDT)" width="220" />
      <el-table-column prop="pnlCouponDeduct" label="盈亏抵扣券抵扣金额(USDT)" width="220" />
      <el-table-column prop="feeDay" label="手续费日返" width="160" />
      <el-table-column prop="feeDayGrant" label="手续费日返-已发放" width="160" />
      <el-table-column prop="profitWeek" label="赠币" width="160" />
      <el-table-column prop="netProfit" label="净利润" width="160" />

      <!-- <el-table-column prop="totalProfit" label="总盈亏" />
      <el-table-column prop="ptprofit" label="平台盈亏" />
      <el-table-column prop="personalProfit" label="散户净盈亏" />
      <el-table-column prop="groupProfit" label="团队净盈亏" />
      <el-table-column prop="realProfit" label="平台实际盈亏" /> -->
    </el-table>
    <pagination :size="paginations.size" :page="paginations.page" :total="totalCount" @pageChanged="handlePageChanged">
    </pagination>

    <el-dialog :visible="detailDialogVisible" title="余额明细" @close="closeDialog" width="95%">
      <el-input placeholder="用户ID" v-model="userId" clearable class="userIdInput"></el-input>
      <el-button size="mini" @click="handleSearch" type="primary">搜索</el-button>
      <el-table :data="dialogList" style="width: 100%" class="myTable detail-balance-table" max-height="400px">
        <!-- <el-table-column prop="date" label="日期" width="150">
        </el-table-column> -->
        <el-table-column prop="userId" label="用户UID" min-width="100" />
        <el-table-column prop="tigerBalance" label="合约总资产" min-width="110" />
        <el-table-column prop="spotBalance" label="现货总资产" min-width="110" />
        <el-table-column prop="copyBalance" label="跟单总资产" min-width="110" />
        <el-table-column prop="realizedProfit" label="平仓盈亏" min-width="100" />
        <el-table-column prop="fee" label="手续费" min-width="90" />
        <el-table-column prop="experienceDeductFee" label="体验金抵扣手续费(USDT)" min-width="220" />
        <el-table-column prop="experiencePnlDeduct" label="体验金抵扣盈亏(USDT)" min-width="210" />
        <el-table-column prop="experienceFundingFeeDeduct" label="体验金抵扣资金费(USDT)" min-width="220" />
        <el-table-column prop="feeCouponDeduct" label="手续费抵扣券抵扣金额(USDT)" min-width="220" />
        <el-table-column prop="pnlCouponDeduct" label="盈亏抵扣券抵扣金额(USDT)" min-width="220" />
        <el-table-column prop="profitTotal" label="盈利" min-width="90" />
        <el-table-column prop="profit" label="合约当前持仓未实现盈亏" min-width="130" />
        <el-table-column prop="tigerRealizedProfit" label="合约当前持仓已实现盈亏" min-width="130" />
      </el-table>
      <pagination :size="paginationsDialog.size" :page="paginationsDialog.page" :total="totalCountDialog"
        @pageChanged="handlePageChangedDialog">
      </pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible="recordsDialogVisible" :title="title" @close="closeRecords" width="70%">
      <el-input placeholder="用户ID" v-model="userId" clearable class="userIdInput"></el-input>
      <el-select class="userIdInput" clearable v-model="coinType" filterable placeholder="选择币种">
        <el-option v-for="item in symbolList" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>

      <el-button size="mini" @click="handleSearchRecords" type="primary">搜索</el-button>
      <div class="pl_total_box total_box">
        <div v-for="item in recordsTotal" :key="item.id" class="pl_total total">
          <span>{{ item.txCoin }}汇总</span>
          <span></span>
          <span>{{ item.totalAmount }}</span>
        </div>
      </div>

      <el-table :data="recordsList" style="width: 100%" class="myTable" max-height="400px">
        <!-- <el-table-column prop="date" label="日期" width="150">
        </el-table-column> -->
        <el-table-column prop="userId" label="用户UID" />
        <el-table-column prop="txCoin" label="币种" />
        <el-table-column prop="txAmount" label="数量" />
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="paginationsDialog.size" :page="paginationsDialog.page" :total="recordsTotalCountDialog"
        @pageChanged="handlePageChangedDialog">
      </pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeRecords">取消</el-button>
      </span>
    </el-dialog>
    <FundDialog :fundDialogVisible="fundDialogVisible" :topChannelUserId="userId" :fundRow="fundRow"
      @closeFundDialog="closeFundDialog" />
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import api from '../../api'
import moment from 'moment'
import FundDialog from '../FundDialog'
export default {
  props: ['totalCount', 'tabData', 'topChannelUserId'],
  data() {
    return {
      fundDialogVisible: false,
      paginations: {
        page: 1,
        size: 10,
      },
      detailDialogVisible: false,
      userId: '',
      paginationsDialog: {
        page: 1,
        size: 10,
      },
      remark: '',
      totalCountDialog: 0,
      cacheRow: {},
      dialogList: [],
      title: '充值记录',
      recordsDialogVisible: false,
      recordsRow: {},
      type: 1,
      txType: 1,
      coinType: '',
      symbolList: [
        'USDT',
        'BTC',
        'SHIB',
        'BABYDOGE',
        'ETH',
        'RRR',
        'LTC',
        'DOGE',
        'XRP',
        'AVAX',
        'ETC',
        'TRX',
        'MATIC',
        'SOL',
        'PEPE',
        'SATS',
        'AAVE',
        'ARB',
        'BNB',
        'DOT',
        'FIL',
        'LINK',
        'OP',
        'ORDI',
        'BCH',
        'TON',
        'UNI',
      ],
      startTime: '',
      endTime: '',
      recordsTotalCountDialog: '',
      recordsTotal: 0,
      recordsList: [],
    }
  },
  components: { Pagination, FundDialog },
  computed: {},
  watch: {
    topChannelUserId: {
      handler(val) {
        this.userId = val
      },
      immediate: true,
    },
  },
  mounted() {
    this.userId = this.topChannelUserId
  },
  methods: {
    openFundDialog(row) {
      this.fundRow = row
      this.fundDialogVisible = true
    },
    closeFundDialog() {
      this.fundRow = null
      this.fundDialogVisible = false
    },

    handlePageChanged(pagination, flag) {
      this.paginations = pagination
      !flag && this.$emit('refreshTab', this.paginations)
    },
    handlePageChangedDialog(pagination) {
      this.paginationsDialog = pagination
      this.getList()
    },
    openDialog(row) {
      this.detailDialogVisible = true
      this.cacheRow = row
      this.getList()
    },
    closeDialog() {
      this.detailDialogVisible = false
      this.cacheRow = false
      this.paginationsDialog = { page: 1, size: 10 }
    },
    openRecords(row, type, title, remark) {
      const { date } = row
      const time = moment(date, 'YYYY-MM-DD')
      this.startTime = time.valueOf()
      this.remark = remark
      this.txType = type
      const nextDay = time.clone().add(1, 'days')
      this.endTime = nextDay.valueOf() - 1000

      this.recordsDialogVisible = true
      this.recordsRow = row
      this.title = title
      this.getRecords()
    },
    closeRecords() {
      this.recordsDialogVisible = false
      this.recordsRow = {}
      this.paginationsDialog = { page: 1, size: 10 }
      this.userId = ''
      this.title = ''
      this.type = ''
      this.startTime = ''
      this.endTime = ''
      this.coinType = ''
      this.recordsTotal = 0
      this.recordsTotalCountDialog = 0
      this.recordsList = []
    },
    getList() {
      api
        .userTradeInfo({
          userId: this.userId,
          time: this.cacheRow.date,
          ...this.paginationsDialog,
        })
        .then((res) => {
          if (res.code == 0) {
            this.dialogList = res.data.list
            this.totalCountDialog = res.data.totalCount
          }
        })
    },
    handleSearch() {
      this.getList()
    },
    getRecords() {
      api
        .getRecords({
          userId: this.userId,
          coinType: this.coinType,
          txType: this.txType,
          startTime: this.startTime,
          remark: this.remark,
          endTime: this.endTime,
          txStatus: 0,
          ...this.paginationsDialog,
        })
        .then((res) => {
          if (res.code == 0) {
            this.recordsList = res.data.list
            this.recordsTotalCountDialog = res.data.totalCount
          }
        })
      api
        .getRecordsTotal({
          userId: this.userId,
          coinType: this.coinType,
          txType: this.txType,
          remark: this.remark,
          startTime: this.startTime,
          endTime: this.endTime,
          txStatus: 0,
          ...this.paginationsDialog,
        })
        .then((res) => {
          if (res.code == 0) {
            this.recordsTotal = res.data
          }
        })
    },

    handleSearchRecords() {
      this.getRecords()
    },
  },
}
</script>

<style lang="less" scoped>
.el-table__header {
  width: 100% !important;

  th.el-table__cell.is-leaf {
    background: #ccc;
  }
}

.el-table__body {
  width: 100% !important;
}

.userBalance {
  color: #409eff;
  cursor: pointer;
}

.userIdInput {
  width: 300px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.el-dialog__body {
  padding-top: 10px !important;
}

.detail-balance-table {
  /deep/ .el-table__header th .cell {
    white-space: nowrap;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
